import type { AppContainer } from '../container';
import { getAppContainer } from '../container';

export const useContainer = (): AppContainer => getAppContainer();
